import { useState } from 'react';
import TierConfigService from './TierConfigService';

function useManageTierConfigs() {
    const [tierConfigs, setTierConfigs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshTierConfigs = async () => {
        setIsLoading(true);
        try {
            const response = await TierConfigService.getTierConfigs();
            setTierConfigs(response.data);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const editTierConfig = async (tierConfigId, updatedData) => {
        setIsLoading(true);
        try {
            await TierConfigService.editTierConfig(tierConfigId, updatedData);
            refreshTierConfigs();
        } finally {
            setIsLoading(false);
        }
    };

    return {
        tierConfigs,
        isLoading,
        error,
        editTierConfig,
        refreshTierConfigs
    };
}

export default useManageTierConfigs;
